import up from 'unpoly';

up.compiler('.js-prevent-paste', (el) => {
    el.addEventListener('paste', (event) => {
        event.preventDefault();
    });
});
